import { FC, memo, useEffect, useState } from "react";
import isEmpty from "lodash/isEmpty";

import LanguageSelect from "@components/LanguageSelect/LanguageSelect";
import { AVAILIO_LOGO } from "@constants/assets";
import { HeaderProps } from "@models/components/kiosk.model";

const Header: FC<HeaderProps> = ({ isLoading, logoImage }) => {
  const [logo, setLogo] = useState<string | undefined>("");

  useEffect(() => {
    if (isLoading) return;
    if (isEmpty(logoImage)) {
      setLogo(AVAILIO_LOGO);
      return;
    }

    setLogo(logoImage);
  }, [logoImage, isLoading]);

  return (
    <header
      className="navbar navbar-expand-md navbar-light bg-white fg-overview-profile-wrap sticky-top py-3"
      data-testid="kiosk-header"
    >
      <div className="container px-4">
        <div className="d-flex align-items-center justify-content-between w-100 position-relative">
          <div className="flex-fill d-flex align-items-center"></div>

          <div className="position-absolute start-50 translate-middle-x">
            {!isLoading && (
              <img
                src={logo}
                onError={() => setLogo(AVAILIO_LOGO)}
                className="fg-logo-img"
                alt="App logo"
              />
            )}
          </div>

          <div className="flex-fill d-flex justify-content-end">
            <LanguageSelect />
          </div>
        </div>
      </div>
    </header>
  );
};

export default memo(Header);
